import { render, staticRenderFns } from "./Treatment.vue?vue&type=template&id=e788a9fe&scoped=true&"
import script from "./Treatment.vue?vue&type=script&lang=js&"
export * from "./Treatment.vue?vue&type=script&lang=js&"
import style0 from "./Treatment.vue?vue&type=style&index=0&id=e788a9fe&scoped=true&lang=css&"
import style1 from "./Treatment.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e788a9fe",
  null
  
)

export default component.exports